<div
    id="sb-block-{{ block.uuid }}"
    class="block-container d-flex flex-column gap-{{ block.options?.gap_y || 0 }}">
    @for (componentItem of block.children; track $index) {
        <div class="sb-block">
            <ng-container
                *ngComponentOutlet="
                    getComponent(componentItem.component);
                    inputs: {
                        options: componentItem.inputs?.options,
                    }
                " />
        </div>
    }
</div>
